import en from "./strings.en";
import hy from "./strings.hy";
import ky from "./strings.ky";
import uz from "./strings.uz";
import kk from "./strings.kk";

import { getSupportedLocale } from "../utils/locale";

// Казахский - kk
// Кыргызский - ky
// Узбекский - uz
// Армянский - hy

const locale = getSupportedLocale();

const ru = {
  more: "Еще",
  freeUser: "Бесплатный",
  at: "ат",
  days: "дн",
  serviceUnavailable: "сервис недоступен",
  serviceUnavailableCapitalize: "Cервис недоступен",
  room: "Кабинет",
  Chief: "Руководитель",
  Admin: "Администратор",
  Manager: "Менеджер",
  heading: "Не пропускайте сообщения",
  text: "Включите уведомления. Браузер спросит разрешения отправлять уведомления — разрешите ему. После этого сообщения от ATI.SU будут появляться внизу экрана, на каком бы сайте вы ни находились.",
  btnText: "включить уведомления",
  importantMessagesPluralize: {
    one: "важное сообщение",
    few: "важных сообщения",
    many: "важных сообщений",
    other: "важных сообщений",
  },
  CoWorker: "Сотрудник",
  score: "Счет",
  firman: "Лицензии",
  paidFor: "Оплачено до",
  add: "Добавить",
  extend: "Продлить",
  freeAccess: "У вас бесплатный доступ",
  licenseDescr:
    "Вы можете просматривать только бесплатные машины и грузы. Чтобы видеть все — купите лицензию.",
  whatLicensed: "Что еще дают лицензии?",
  selectLicense: "Выбрать лицензию",
  settings: "Настроить",
  recurrentPaymentFailed: "Не удалось списать автоплатёж",
  moreInfo: "Подробнее",
  pay: "Оплатить",
  conditions: "Условия",
  logout: "Выход",
  view: "Посмотреть",
  readLater: "Прочитаю позже",
  participantsSearch: "Поиск\xa0участников\xa0ATI.SU",
  advancedSearch: "Расширенный поиск",
  advanced: "Расширенный",
  cannotFindFirm: "Мы не нашли такого участника.",
  somethingWentWrong: "Что-то пошло не так.",
  somethingWentWrongWithoutDot: "Что-то пошло не так",
  byExtendedSearch: "расширенным поиском",
  tryUsing: "Попробуйте воспользоваться",
  notificationSettings: "Настройки уведомлений",
  noNewNotifications: "Новых уведомлений нет",
  viewedNotifications: "Прочитанные уведомления",
  downloadLoadsAndTrucks: "Скачайте АТИ Грузы и Транспорт",
  receiveNotifications:
    "Получайте уведомления о новых грузах на ваш телефон или планшет",
  forAndroid: "Android",
  forIPhoneIPad: "IPhone и IPad",
  markAllAsRead: "Отметить всё как прочитанные",
  soundOn: "Включить звук",
  soundMute: "Выключить звук",
  loads: "Грузы",
  transport: "Транспорт",
  checks: "Проверки",
  tenders: "Тендеры",
  news: "Новости",
  forums: "Форумы",
  docs: "Доки",
  atiDocs: "АТИ-Доки",
  tracking: "Мониторинг",
  shipmentTracking: "GPS-мониторинг",
  insurance: "Страхование",
  ratingOfParticipants: "Рейтинг",
  contacts: "Контакты",
  loans: "Займы",
  truckmarket: "Продажа транспорта",
  yourLoads: "Ваши грузы",
  addLoad: "Добавить груз",
  searchLoads: "Найти грузы",
  load: "Груз",
  yourTrucks: "Ваши машины",
  addTruck: "Добавить машину",
  searchTrucks: "Найти машины",
  truck: "Машину",
  orders: "Заказы",
  ordersFromYou: "Заказы от вас",
  ordersToYou: "Заказы вам",
  ordersToDriver: "Заявка водителю",
  vehicleFleet: "Автопарк",
  drivers: "Водители",
  organizations: "Организации",
  contractors: "Контрагенты и контракты",
  boards: "Площадки",
  yourBoards: "Ваши площадки",
  invitationsAndApplications: "Приглашения и заявки",
  youParticipate: "Вы участвуете",
  invitations: "Приглашения",
  aboutBoards: "О Площадках",
  yourTenders: "Ваши Тендеры",
  addTenders: "Добавить тендер",
  catalogs: "Справочники",
  directionsLists: "Cписки направлений",
  companiesList: "Списки фирм",
  requisites: "Ваши реквизиты",
  registration: "Регистрация",
  toRegister: "Зарегистрироваться",
  login: "вход",
  toLogin: "войти",
  code: "Код",
  copied: "скопировано",
  cars: "Машины",
  rating: "Рейтинг",
  veh: "ТС",
  guaranteedPayment: "Гарантированный платёж",
  daysRemaining: ["день", "дня", "дней"],
  remain: ["остался", "осталось"],
  paymentHaveToBeReceived: "Оплата должна поступить до",
  paymentHadToBeReceived: "Оплата должна была поступить до",
  expired: "просрочен",
  avatar: "Аватар",
  accountReplenishment: "Пополнить счет",
  from: "от",
  rub: "руб",
  aMonth: "в мес",
  profile_freeAccessTooltip:
    "Если вы активируете лицензию на просмотр машин или грузов вы сможете:",
  viewContactsForCarsAndCargoes:
    "Просматривать контакты по машинам и\xa0грузам",
  viewPassports:
    "Просматривать паспорта участников ATI.SU с\xa0отзывами и\xa0претензиями",
  Common: "Общий",
  yourContact: "Ваш контакт",
  noLicenseInfo: "Информация о\xa0действующих лицензиях временно недоступна",
  shortMonths: {
    0: "янв.",
    1: "фев.",
    2: "мар.",
    3: "апр.",
    4: "мая",
    5: "июня",
    6: "июля",
    7: "авг.",
    8: "сен.",
    9: "окт.",
    10: "нояб.",
    11: "дек.",
  },

  /** месяца в родительном падеже */
  januaryGen: "января",
  februaryGen: "февраля",
  marchGen: "марта",
  aprilGen: "апреля",
  mayGen: "мая",
  juneGen: "июня",
  julyGen: "июля",
  augustGen: "августа",
  septemberGen: "сентября",
  octoberGen: "октября",
  novemberGen: "ноября",
  decemberGen: "декабря",

  year: "г.",

  recommendChangingBrowser: "Рекомендуем сменить браузер",
  someSiteFeaturesMayNotWorkInThe: "Часть функций сайта может не работать в",
  thatYouAreUsing: ", который вы используете.",
  download: "Скачать",
  notificationsPluralize: {
    few: "новых уведомления",
    many: "новых уведомлений",
    one: "новое уведомление",
    other: "новых уведомлений",
  },
  messagesPluralize: {
    oneNumber: "новое сообщение",
    fewNumbers: "новых сообщения",
    manyNumbers: "новых сообщений",
    other: "новых сообщений",
  },
  remainPluralize: {
    one: "остался",
    few: "осталось",
    many: "осталось",
    other: "осталось",
  },
  daysRemainingPluralize: {
    one: "день",
    few: "дня",
    many: "дней",
    other: "осталось",
  },
  contactsByLicense: {
    one: "доп.\u00A0контакт",
    few: "доп.\u00A0контакта",
    many: "доп.\u00A0контактов",
    other: "доп.\u00A0контакт",
  },
  youHave: "У вас",
  allRead: "Все прочитаны",
  createBoard: "Создать Площадку",
  unreadNotifications: "Непрочитанные уведомления",
  noUnreadNotifications: "Нет прочитанных уведомлений",
  notifications: "Уведомления",
  atiMessenger: "АТИ Мессенджер",
  viewUnread: "Смотреть непрочитанные",
  readAll: "Смотреть все",
  viewAll: "Прочитать все",
  automaticPaymentEnabled: "Включен автоплатеж",
  clickBackAndTryAgain: "Нажмите Назад и попробуйте еще раз.",
  back: "Назад",
  sorrySomethingWentWrong: "Что-то пошло не так.",
  loadingError: "Ошибка загрузки.",
  addingNewLicensesWillBeAvailableAfterRenewal:
    "Добавление новых лицензий будет доступно после продления",
  searchParticipants: "Поиск участников",
  stars: "Звёзды",
  refresh: "Обновить",
  loadsOnBoards: "Грузы на площадках",
  sorrySomethingWentWrongPleaseTryAgain:
    "Что-то пошло не\xA0так, попробуйте ещё раз",
  participantHasNoPaidLicenses: "У пользователя нет оплаченных лицензий",
  anErrorHasOccurredRefreshThePage: "Произошла ошибка, обновите страницу",
  supportNGINX:
    "АвтоТрансИнфо - один из миллионов сервисов, которые используют NGINX. Open-source технологии должны быть свободными.",
  browserIsNotOptimal:
    "Ваш браузер не оптимален для работы с ATI.SU. Установите другой",
  weRecommend: "Мы рекомендуем",
  or: "или",
  theSiteWillWorkMoreStable: "В них сайт будет работать стабильнее",
  ICantUseAnotherBrowser: "Я не могу использовать другой браузер",
  howToInstallAnotherBrowser: "Как установить другой браузер",
  tnxForVote: "Спасибо за голос",
  confirm: "Подтвердить",
  resend: "Отправить повторно",
  sendCode: "Отправить код",
  cancel: "Отмена",
  codeSent: "Код отправлен",
  codeSentOnNewEmail:
    "На\xA0новую почту отправлено письмо с\xA0кодом для подтверждения",
  resendAgain: "Отправить повторно через",
  seconds: "\xA0сек.",
  loanAvailable: "Вам доступно",
  cargoOwnerButtonAvailable: "ATI.SU с нуля",
  youCan: "Вы\xA0можете",
  unsubscribeFrom: "отписаться от\xA0рассылки",
  turnPartnerOffers: "или отключить все предложения партнеров",
  inNotificationSettings: "в\xA0настройках уведомлений",
  youCanUnsubscribeFromPartners:
    "Вы\xA0можете отписаться от\xA0предложений партнёров ATI.SU {{inSettings}}",

  allServices: "Все сервисы",

  automationHeader: "Автоматизация перевозок",
  statisticHeader: "Статистика",
  securityHeader: "Безопасность",
  comunicationHeader: "Общение",
  addInstrumentsHeader: "Доп.\xA0инструменты",
  usefulHeader: "Полезное",

  apiLink: "API ATI.SU",
  apiLinkDescription:
    "Интегрируйте ваше корпоративное ПО с\xA0сервисами\xA0ATI.SU",
  automationLink: "Автоматизация",
  gpsLink: "GPS-мониторинг",
  gpsDescription:
    "Отслеживайте местоположение транспорта и\xA0статус перевозки онлайн",
  docsLink: "АТИ-Доки (ЭДО)",
  docsDescription:
    "Создавайте и\xA0обменивайтесь эл.\xA0документами с\xA0партнёрами",
  ordersLink: "Заказы",
  ordersDescription:
    "Полностью автоматизируйте перевозки — от\xA0поиска партнёров до\xA0аналитики",
  boardsLink: "Площадки ATI.SU",
  boardsDescription:
    "Создайте свою\xA0платформу для\xA0работы с\xA0доверенными партнёрами",
  tendersLink: "Тендеры",
  tendersDescription:
    "Заключайте долгосрочные контракты на\xA0десятки и\xA0сотни перевозок",
  auctionLink: "Торги",
  auctionDescription: "Найдите для\xA0груза оптимальную цену",
  indexLink: "Индекс ATI.SU\xA0FTL\xA0РФ",
  indexDescription:
    "Динамика ставок по\xA0самым популярным направлениям в\xA0РФ",
  middlePriceLink: "Средние ставки",
  middlePriceDescription:
    "Актуальные ставки в\xA0руб/км по\xA0тысячам направлений в\xA0РФ",
  cargoMapLink: "Карта грузов",
  profitableDestinationsLink: "Выгодные направления",
  profitableDestinationsDesription: "",
  unlimitedCheckLink: "Безлимитная проверка контрагентов",
  unlimitedCheckDescription:
    "Сигнал безопасности + отчёт + расширенный анализ по\xA0фирмам из\xA0РФ",
  guaranteePaymentLink: "Гарантия оплаты перевозки",
  guaranteePaymentDescription: "",
  checkLink: "Проверки ATI.SU",
  checkShortLink: "Проверки",
  checkDescription:
    "Проверьте юрлицо, физлицо или\xA0ТС, чтобы не\xA0лишиться груза или\xA0оплаты",
  trafficLightLink: "Светофор+",
  trafficLightDescription:
    "Сигнал безопасности + отчёт по\xA0фирмам из\xA0России и\xA0Казахстана",
  messengerLink: "АТИ Мессенджер",
  messengerDescription:
    "Договоритесь о\xA0перевозке, отправьте фото и\xA0документы участнику ATI.SU",
  forumsLink: "Форумы",
  forumsDescription: "Обсуждайте новости, обменивайтесь опытом и\xA0мнениями",
  realTruckLink: "Поиск активных перевозчиков",
  realTruckDescription:
    "Если груз долго не\xA0уходит — найдите подходящего перевозчика",
  distanceCalculatorLink: "Расчёт расстояний",
  distanceCalculatorDescription:
    "Планируйте маршрут для\xA0грузового транспорта",
  chainsLink: "Цепочки грузов",
  chainsDescription:
    "Постройте наиболее выгодную цепочку с\xA0максимальной ставкой",
  academyLink: "Академия ATI.SU",
  academyDescription: "Научитесь эффективно решать логистические задачи",
  loansLink: "Займы",
  loansDescription: "Особые условия для\xA0участников ATI.SU",
  newsLink: "Новости",
  newsDescription:
    "Узнавайте первым о\xA0самых важных новостях в\xA0мире грузоперевозок",
  partnershipLink: "Реферальная программа",
  partnershipDescription:
    "Приглашайте новых пользователей и зарабатывайте вместе с\xA0нами",
  ratingLink: "Рейтинг участников ATI.SU",
  ratingDescription: "Найдите лучших участников в\xA0вашем регионе",
  insuranceLink: "Страхование",
  insuranceDescription:
    "Застрахуйте груз или\xA0ответственность в\xA0несколько кликов",
  truckmarketLink: "Продажа транспорта",
  truckmarketDescription:
    "Продавайте, покупайте или\xA0арендуйте транспорт и\xA0спецтехнику",
  timeSlots: "Временные окна",
  timeSlotsDescription:
    "Организуйте эффективную работу склада без\xA0очередей и\xA0штрафов",
  partnersOffers: "Спецпредложения партнёров",
  catalogsLink: "Справочники",
  ticketsLink: "Обращения (тикеты)",
  courierLink: "АТИ Курьер",

  loadsSearch: "Поиск грузов",
  mainMenu_loads: "Грузы",
  trucksSearch: "Поиск машин",
  mainMenu_trucks: "Машины",

  mainMenu_atiDocs_short: "АТИ-Доки",

  mainMenu_analitics: {
    statistika_rynka: "Статистика рынка",
    servisy_dlya_analitiki: "Сервисы для аналитики",
    dinamika_rynka: "Динамика рынка",
    rynok_v_cifrah: "Рынок в цифрах",
  },

  menu_analitics_averageRates: "Средние ставки",
  menu_analitics_cargomap: "Карта грузов",
  menu_analitics_profitdirections: "Выгодные направления",
  menu_analitics_index: "Индекс",

  cargoOwners: "Грузовладельцам",

  submenu_codeCopied: "Код скопирован",

  menu_section_loadsAndOrders: "Грузы и заказы",
  menu_addLoad: "Добавить груз",
  menu_yourLoads: "Ваши грузы",
  menu_yourTenders: "Ваши тендеры",
  menu_addTenders: "Добавить тендер",
  menu_yourOrders: "Заказы от вас",
  menu_reports: "Отчёты",
  menu_billing: "Оплатить ATI.SU",

  menu_section_boards: "Площадки",
  menu_invitations: "Приглашения",
  menu_yourBoards: "Ваши площадки",
  menu_youParticipate: "Вы участвуете",
  menu_createBoard: "Создать площадку",
  menu_boards: "Площадки",

  menu_section_carrierSearch: "Поиск перевозчиков",
  menu_trucksSearch: "Найти машину",
  menu_activeCarriers: "Активные перевозчики",
  menu_rating: "Рейтинг участников",
  menu_safetyMemo: "Памятка по безопасности",

  menu_section_catalogs: "Справочники",
  menu_organizations: "Организации",
  menu_partnersAndContracts: "Контрагенты и контракты",
  menu_yourRequisites: "Ваши реквизиты",
  menu_firmLists: "Списки фирм",
  menu_directionLists: "Списки направлений",
  menu_catalogs: "Ваши справочники",
  menu_drivers: "Водители",

  carriers: "Перевозчикам",

  menu_section_trucksAndOrders: "Машины и заказы",
  menu_addTruck: "Добавить машину",
  menu_yourTrucks: "Ваши машины",
  menu_ordersToYou: "Заказы вам",

  menu_section_loadsSearch: "Поиск грузов",
  menu_loadsSearch: "Поиск грузов",
  menu_cargoChains: "Цепочки грузов",
  menu_boardsSearch: "Площадки",

  menu_boardsLoadsSearch: "Грузы на Площадках",

  menu_section_trucksSearch: "Поиск перевозчиков",
  menu_exchange: "Биржа ATI.SU",
  menu_gps: "GPS-мониторинг",

  menu_section_usefull: "Полезное",

  menu_section_yourDocuments: "Ваши документы",
  menu_section_rouming: "Роуминг",
  menu_section_createDocument: "Создать документ",
  menu_inbox: "Входящие",
  menu_awaitingDecision: "Ожидают решения",
  menu_closing: "Закрывающие от ATI.SU",
  menu_yourCounterparties: "Ваши контрагенты",
  menu_yourCertificates: "Ваши сертификаты ЭП",
  menu_invoice: "Счёт на оплату",
  menu_applicationAgreement: "Договор-заявка",
  menu_certificateOfCompletion: "Акт выполненных работ",
  menu_otherDocument: "Другой документ",

  menu_add_order: "Добавить заявку водителю",

  burger_addLoad: "Добавить груз",
  burger_addTruck: "Добавить машину",

  bottom_yourLoad: "Ваши грузы",
  bottom_loads: "Грузы",
  bottom_yourTrucks: "Ваши машины",
  bottom_trucks: "Машины",
  bottom_services: "Сервисы",
  bottom_orders: "Заказы",
  bottom_profile: "Профиль",

  mainMenu_atiDocs: "АТИ-Доки (ЭДО)",

  profile_serviceUnavailable: "Cервис недоступен",
  profile_freeUser: "Бесплатный",
  profile_atis: "ат.",
  profile_days: "дн.",
  profile_yourContact: "Ваш контакт",
  profile_refresh: "Обновить",
  profile_score: "Счет",
  profile_room: "Кабинет",
  profile_logout: "Выйти",
  profile_freeAccess: "Бесплатный доступ",
  profile_freeAccessText:
    "Вы можете просматривать только бесплатные машины и грузы. Чтобы видеть все – купите лицензию.",
  profile_whatsMore: "Что ещё дают лицензии?",
  profile_selectLicense: "Выбрать лицензию",
  profile_fromPerMonth: "от 460 ₽ в месяц",
  profile_payBefore: "Оплатить до {{val}}",
  profile_guaranteedPayment: "Гарантированный платёж.",
  profile_remainPluralize: {
    one: "Остался",
    few: "Осталось",
    many: "Осталось",
    other: "Осталось",
  },
  profile_daysRemainingPluralize: {
    one: "день",
    few: "дня",
    many: "дней",
    other: "",
  },
  profile_conditions: "Условия",
  profile_pay: "Оплатить",
  profile_settings: "Настроить",
  profile_automaticPaymentEnabled: "Включен автоплатёж",
  profile_paidFor: "Оплачено до {{val}}",
  profile_addingNewLicenses: "Добавление новых лицензий",
  profile_WillBeAvailableAfterRenewal: "будет доступно после продления",
  profile_add_new: "Добавить лицензию",
  profile_extend: "Продлить",
  profile_add: "Добавить",
  profile_recurrentPaymentFailed: "Не удалось списать автоплатёж",
  profile_code: "Код",

  search_participantsSearch: "Поиск\xa0участников",
  search_atiParticipantsSearch: "Поиск\xa0участников ATI.SU",
  search_advancedSearch: "Расширенный поиск",
  search_advanced: "Расширенный",
  search_phoneAndEmailRestriction:
    "Поиск по номеру телефона и другим контактным данным доступен платным участникам.",
  search_pricesAndRates: "Цены и тарифы",

  nps_recomendChance:
    "С какой вероятностью вы порекомендуете ATI.SU своим знакомым?",
  nps_errorTryAgain:
    "Попробуйте ещё раз. Произошла ошибка при отправке ответа.",
  nps_rateNoRecommend: "ни за что не порекомендую",
  nps_rateRecommend: "точно порекомендую",
  nps_thanksForRate: "Спасибо за ответ ({{val}} из 10)",
  nps_commentYourAnswer: "Прокомментируйте ответ",
  nps_send: "Отправить",
  nps_tryAgain: "Попробуйте ещё раз.",
  nps_errorWhileSending: "Произошла ошибка при отправке ответа.",
  nps_answerSended: "Ответ отправлен. Спасибо за участие в опросе",
  nps_youAlreadyVoted: "Вы уже проголосовали. Спасибо за участие в опросе",

  security_header:
    "Как вы считаете, насколько безопасно работать через ATI.SU?",
  security_rateNoRecommend: "совершенно не безопасно",
  security_rateRecommend: "абсолютно безопасно",
  security_headerSuccess: "Спасибо за ответ",
  security_headerDescription: "Можете оставить комментарий, если хотите",

  outdated_outdatedBrowserTitle: "Ваш браузер может работать с\u00A0ошибками",
  outdated_ieWasFound:
    "Ваш браузер устарел. Чтобы Биржа ATI.SU работала без ошибок, установите один из\u00A0рекомендуемых браузеров:",
  outdated_outdatedBrowserWasFound:
    "Ваша версия браузера устарела. Чтобы Биржа ATI.SU работала без\u00A0ошибок, обновите браузер:",
  outdated_update: "Обновить",
  outdated_remindLater: "Напомнить об этом позже",
  outdated_howToUpdate: "Как обновить браузер",
  outdated_howToInstallAnotherBrowser: "Как установить браузер",

  refresh_attemptsLimitError:
    "Превышено кол-во обновлений, повторите через 5 минут",

  notification_unsubscribePartnerText:
    "Вы можете {{val1}} или отключить все предложения наших партнёров {{val2}}",
  notification_unsubscribePartnerATISU:
    "отписаться от рассылки этого партнёра ATI.SU",
  notification_notificationsSettings: "в настройках уведомлений",
  loan_forFuel: "на топливо", // строка используется только на русской локали

  feed_checkAll: "Отметить всё как прочитанное",
  feed_allRead: "Все прочитаны",
  feed_showMessegesText: "Показывать текст сообщений мессенджера",
  feed_groupedMessageCounter: {
    one: "сообщение",
    few: "сообщения",
    many: "сообщений",
    other: "сообщений",
  },

  /** Это группе строк не нужен перевод */
  languageInformer_title: "Выберите язык интерфейса",
  languageInformer_description:
    "Вы всегда сможете изменить свой выбор в кабинете или подвале сайта.",
  languageInformer_button: "Сохранить",
  /** Конец группы */
};

const strings = {
  ru,
  en: { ...ru, ...en },
  hy: { ...ru, ...hy },
  ky: { ...ru, ...ky },
  uz: { ...ru, ...uz },
  kk: { ...ru, ...kk },
};

export default strings[locale];

export { locale };
